<div class="tabs">
  <ul role="tablist" class="tabs__list">
    <li role="presentation" class="tabs__item">
      <a class="tabs__link" [class.tabs__link_active]="currentTab === 'settings'"
         (click)="onSelectLink('settings')">
        {{'settings.general-settings-tab' | translate | titlecase }}</a>
    </li>

    <li role="presentation" class="tabs__item">
      <a class="tabs__link" [class.tabs__link_active]="currentTab === 'notifications'"
         (click)="onSelectLink('notifications')">
        {{'settings.notification-settings-tab' | translate | titlecase }}</a>
    </li>
  </ul>
</div>
